/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ForgePersonalSettingsPageType from '@jira/spa-apps__forge-personal-settings/src/ForgePersonalSettingsPageShell.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyForgePersonalSettingsPage: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof ForgePersonalSettingsPageType>(
		() =>
			import(
				/* webpackChunkName: "async-forge-spa-personal-settings", jiraSpaEntry: "async-forge-spa-personal-settings" */ '@jira/spa-apps__forge-personal-settings/src/ForgePersonalSettingsPageShell.tsx'
			),
	);

export const ForgePersonalSettingsPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyForgePersonalSettingsPage}
		pageId="forge-spa-personal-settings"
		shouldShowSpinner
	/>
);

export default ForgePersonalSettingsPage;
